import { Col, Container, Row } from "reactstrap";
import AuthLoginFrom from "./AuthLoginFrom";
import RatioImage from "../CommonElements/RatioImage";
import { dynamicImage } from "../Service/DynamicImage";

const LoginPage = () => {
  return (
    <Container fluid className="p-0">
      <Row>
        <Col xl="7" className="p-0">
          <RatioImage className="bg-img-cover bg-center img-fluid w-100 " src={dynamicImage("login/2.jpg")} alt="looginpage" />
        </Col>
        <Col xl="5" className="p-0">
          <div className="login-card login-dark">
            <AuthLoginFrom />
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default LoginPage;
